#import "../fragments/calltracker-numbers-fragment.graphql"

query GetCallTrackerNumbers {
    callTrackerNumbers {
        ...CallTrackerNumbersFragment
    }
}
